import { render } from "./CurrentTeachers.vue?vue&type=template&id=a8f5944e&scoped=true"
import script from "./CurrentTeachers.vue?vue&type=script&lang=js"
export * from "./CurrentTeachers.vue?vue&type=script&lang=js"

import "./CurrentTeachers.vue?vue&type=style&index=0&id=a8f5944e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8f5944e"]])

export default __exports__